import { useCallback, useMemo } from "react";
import { useDealer } from "../../../hooks/useDealer";
import { ShippingCost } from "../../../interfaces/shippingCostType";
import { errorNotification } from "../../../utils/notification";

type UseShippingCodeOptions = {
  dealerId?: string;
  shippingCode?: string;
  shippingCost?: ShippingCost;
};

export const useShippingCode = (opt: UseShippingCodeOptions) => {
  const { dealerId, shippingCode, shippingCost } = opt;

  const { data, isLoading } = useDealer({ dealerId });

  const handleSendShippingCode = useCallback(() => {
    if (!shippingCost?._id) {
      errorNotification("Método de envío no proporcionado");
      return;
    }
    if (!shippingCode) {
      errorNotification("No se registro el código de rastreo");
      return;
    }
    const shippingProvider = shippingCost?._id ? shippingCost.providerName : "";
    if (!isLoading && data?._id && !!shippingCode && !!shippingProvider) {
      const name = data?.invoiceData?.legalRepresentative ?? "_";
      const trackingURL = shippingCost?.trackingURL;
      const trackingText = !!trackingURL
        ? `Puedes rastrearlo por aquí ${trackingURL}`
        : "";
      const message = `Hola ${name} , ya está listo tu paquete!
El número de seguimiento es ${shippingCode} por ${shippingProvider}. 
${trackingText}

Gracias por tu compra, quedamos pendientes de cualquier duda`;
      const phone = data.phoneNumber?.trim().replace(/ /g, "");
      const whatsappLink = `https://wa.me/${phone}?text=${encodeURIComponent(
        message,
      )}`;
      window.open(whatsappLink, "_blank");
    }
  }, [dealerId, data?._id, isLoading, shippingCode, shippingCost?._id]);

  return {
    handleSendShippingCode,
  };
};
